import { IMPERSONATE, WIZARD_DOCS, backendClient, WIZARD_DOC_WIZARD_DATA, WIZARD_DOC_DELETE, WIZARD_DOC_ADD_CONV, WIZARD_DOC_CONVERSATIONS, WIZARD_DOC_APPROVE, WIZARD_DOC_ARCHIVE, HISTORY, GET_PRODUCTION_ORDER_DATE, IMPORT_CUSTOMER_DESIGN_FILES, CHANGE_ORDER_STATUS, DESIGN_LINKS, GET_DESIGN_FEES, DESIGN_WEI_REJECT, GET_SEW_DISK_FEES, getBackendApiUrl, GET_SEW_DISK_CHARGES, WIZARD_DOC_SEND_PROOF, IMPORT_TO_EASYVIEW } from "../config";
import { SelectedFilters } from "../pages/design-detail/comps/filterOptionsDropdown";
import { HistoryDesign, SelectAllQueryResult, DesignDoc, WizardDocConversation, WizardDocConversationWithOrderN, WizardDocOneTimeFee, SewDiskFee, ReviewTask, SewDiskFeeHourly, SewDiskCharge } from "../types/api-types"
import { IProdOrderLineItem } from "../types/iprod-order"
import { addAuthorizationHeader } from "./network";

export const isEdge = () => {
  return window.location.hostname.includes("-edge") || window.location.hostname.startsWith("stahls-art")
}
// export const generateSanaDoc = async () => {

//   const params = {
//     resource: GENERATE_SANA_DOC,
//     payload: {}
//   };
//   return backendClient.post(params);
// }

// export const createWizardDoc = async (payload: WizardDoc) => {
//   const params = {
//     resource: WIZARD_DOCS,
//     payload: payload
//   };
//   return backendClient.post(params);
// }

export const patchWizardDoc = async (id: string, payload: Partial<DesignDoc>) => {
  try {
    const params = {
      resource: WIZARD_DOCS,
      payload: { id, ...payload }
    };
    return await backendClient.patch(params);
  } catch (error) {
    console.error('Error in patching wizard doc:', error);
    throw error;
  }
}

export const patchWizardDocWizardData = async (id: string, wizardData: any) => {
  try {
    const params = {
      resource: WIZARD_DOC_WIZARD_DATA,
      payload: { designId: id, wizardData }
    };
    return await backendClient.patch(params);
  } catch (error) {
    console.error('Error in patching wizard doc:', error);
    throw error;
  }
}

export const listWizardDocs = async (
  pageNumber?: number,
  pageSize?: number,
  statuses?: string[],
  searchText?: string,
  customerId?: string,
  archived?: boolean,
  products?: SelectedFilters,
  includeTeamJobs?: boolean
): Promise<SelectAllQueryResult<DesignDoc>> => {
  try {
    const queryParams = new URLSearchParams({
      pageNumber: (pageNumber || 1).toString(),
      pageSize: (pageSize || 15).toString(),
      additional: JSON.stringify({
        statuses: statuses || [],
        searchText: searchText || '',
        customerID: customerId || '',
        archived: archived || false,
        includeTeamJobs: includeTeamJobs === true
      })
    });

    const body = products ? { products } : {};

    const params = {
      resource: `${WIZARD_DOCS}/search?${queryParams.toString()}`,
      payload: body
    };

    return await backendClient.post(params);
  } catch (error) {
    console.error('Error in listWizardDocs request:', error);
    throw error;
  }
}

export const getWizardDocById = async (id: string): Promise<DesignDoc> => {
  const params = {
    resource: `${WIZARD_DOCS}/${id}`
  };
  const wizardDoc = await backendClient.get<undefined, DesignDoc>(params);

  const safeParseJSON = (jsonString: string) => {
    try {
      const parsed = JSON.parse(jsonString);
      return parsed;
    } catch (e) {
      return jsonString; // return original string if parsing fails
    }
  };

  //HACK, why doesn't server return JSON?
  if (wizardDoc.productionArtwork) {
    wizardDoc.productionArtwork = safeParseJSON(wizardDoc.productionArtwork as unknown as string);
  }
  if (wizardDoc.productionArtworkPreview) {
    wizardDoc.productionArtworkPreview = safeParseJSON(wizardDoc.productionArtworkPreview as unknown as string);
  }

  return wizardDoc;
};

// export const listWizardDocStatus = async (): Promise<{ id: string, code: string }[]> => {
//   const params = {
//     resource: WIZARD_DOC_STATUS_LIST
//   }
//   const res = await backendClient.get(params) as { data: { id: string, code: string, description: string }[] }
//   const data = res.data
//   return data.map((status) => {
//     return {
//       id: status.id,
//       code: status.code,
//       description: status.description
//     }
//   })
// }

export const addItemConversation = async (conversation: WizardDocConversationWithOrderN): Promise<DesignDoc[]> => {
  const params = {
    resource: WIZARD_DOC_ADD_CONV,
    payload: conversation
  };
  return backendClient.post(params);
}

// export const itemChangeStatus = async (itemId: number, newStatusId: string): Promise<WizardDoc[]> => {
//   const params = {
//     resource: WIZARD_DOC_CHANGE_STATUS,
//     payload: { itemId, newStatusId }
//   };
//   return backendClient.post(params);
// }

export const listWizardDocConversations = async (id: string): Promise<WizardDocConversation[]> => {
  const params = {
    resource: `${WIZARD_DOC_CONVERSATIONS}/${id}`
  };
  return backendClient.get(params);
}

// export const wizardDocAccept = async (designId: number,
//   orderN: string,
//   lineN: string): Promise<WizardDoc[]> => {
//   const params = {
//     resource: WIZARD_DOC_ACCEPT,
//     payload: { designId, orderN, lineN }
//   };
//   return backendClient.post(params);
// }

// export const wizardDocRelease = async (designId: number): Promise<WizardDoc[]> => {
//   const params= {
//     resource: WIZARD_DOC_RELEASE,
//     payload: { designId }
//   };
//   return backendClient.post(params);
// }

export const wizardDocApprove = async (
  designId: string,
  doNotShip = false
): Promise<boolean> => {
  const params = {
    resource: WIZARD_DOC_APPROVE,
    payload: {
      designId,
      ...(doNotShip ? { doNotShip: true } : {})
    }
  };
  return backendClient.post(params);
};

export const wizardDocSendProof = async (
  designId: string,
  doNotShip = false
): Promise<boolean> => {
  const params = {
    resource: WIZARD_DOC_SEND_PROOF,
    payload: {
      designId,
      ...(doNotShip ? { doNotShip: true } : {})
    }
  };
  return backendClient.post(params);
};

export const wizardDocArchive = async (designId: string): Promise<boolean> => {
  const params = {
    resource: WIZARD_DOC_ARCHIVE,
    payload: { itemId: designId }
  };
  return backendClient.post(params);
}

export const wizardDocDelete = async (designId: string): Promise<boolean> => {
  const params = {
    resource: WIZARD_DOC_DELETE,
    payload: { itemId: designId }
  };
  return backendClient.post(params);
}


// export const wizardDocCancel = async (designId: number): Promise<WizardDoc[]> => {
//   const params = {
//     resource: WIZARD_DOC_CANCEL,
//     payload: { designId }
//   };
//   return backendClient.post(params);
// }


export const listHistoryDocs = async (pageNumber?: number, pageSize?: number, customerId?: string, search?: string): Promise<SelectAllQueryResult<HistoryDesign>> => {
  try {
    const params = {
      resource: HISTORY,
      payload: {
        page: pageNumber,
        pageSize,
        customer: customerId,
        search
      }
    };

    const resp = await backendClient.post(params) as SelectAllQueryResult<HistoryDesign>;
    return {
      data: resp.data,
      totalFieldsAffected: resp.totalFieldsAffected
    };
  } catch (error) {
    console.error('Error occurred while fetching history documents:', error);
    throw error;
  }
};


// export const getHistoryDocById = async (id: number): Promise<WizardDoc> => {
//   const params = {
//     resource: `${HISTORY}/${id}`
//   };
//   return backendClient.get(params);
// }

export const getProductionOrderData = async (orderN: string): Promise<IProdOrderLineItem[]> => {
  try {
    const params = {
      resource: `${GET_PRODUCTION_ORDER_DATE}/${orderN}`
    };

    return backendClient.get(params);

  } catch (error) {
    console.error('getProductionOrderData: ', error);
    throw error;
  }
}

// export const listCustomerDesignFiles = async (designId: string, customerId: string) => {
//   const params = {
//     resource: CUSTOMER_DESIGN_FILES,
//     payload: {
//       customer: customerId,
//       designId
//     }
//   };
//   const resp = await backendClient.post(params) as SelectAllQueryResult<WizardDoc>
//   return {
//     data: resp.data,
//     totalFieldsAffected: resp.totalFieldsAffected
//   }
// }

export const importCustomerDesignFiles = async (customerId: string, design: HistoryDesign) => {
  const params = {
    resource: IMPORT_CUSTOMER_DESIGN_FILES,
    payload: {
      customer: customerId,
      design
    }
  };
  try {
    const response = await backendClient.post(params);
    return response as string;
  } catch (error) {
    console.error('importCustomerDesignFiles: ', error);
    throw error;
  }
}

export const changeOrderStatus = async (
  designId: string,
  newStatusId: string
): Promise<boolean> => {
  const params = {
    resource: CHANGE_ORDER_STATUS,
    payload: { designId, newStatusId }
  };
  return backendClient.post(params);
}

export const linkDocument = async (designId: string, orderN: string, lineN: number, relink?: boolean) => {
  const params = {
    resource: DESIGN_LINKS,
    payload: { designId, orderN, lineN, relink }
  };
  return backendClient.post<typeof params['payload'], typeof params['payload'] & { designAlias?: string, needsRelink?: boolean }>(params)
}

export const getDesignFees = async (documentId: string): Promise<WizardDocOneTimeFee[]> => {
  try {
    const params = {
      resource: `${GET_DESIGN_FEES}/${documentId}`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch design Art Charge: ${error}`);
    throw error;
  }
};

export const getQuote = async (wizardData: any): Promise<any> => {
  //https://api.stahls.com/design/buildquote
  //const queryPart = useFallback ? '' : '?priceLevel=INTERCO&country=USA'
  try {
    const resp = await fetch(`${getBackendApiUrl()}/design-quotes`, {
      method: 'POST',
      headers: addAuthorizationHeader({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(wizardData)
    })
    return await resp.json()
  } catch (error) {
    console.error(`Failed to fetch quote: ${error}`);
    return undefined
  }
}

export const rejectProof = async (id: string, adminId: string) => {
  const params = {
    resource: DESIGN_WEI_REJECT,
    payload: { id, adminId }
  };

  return backendClient.post<typeof params['payload'], typeof params['payload']>(params);
};

export const getSewDiskFeesHourly = async (): Promise<SewDiskFeeHourly> => {
  try {
    const params = {
      resource: `${GET_SEW_DISK_FEES}/price`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch Sew Disk Fees: ${error}`);
    throw error;
  }
};

export const getArtFeesHourly = async (): Promise<{uom:string, price:number}> => {
  try {
    const params = {
      resource: `bc-art-fees-price`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch Art Fees: ${error}`);
    throw error;
  }
};

export const getSewDiskFeesForDocumentId = async (documentId: string): Promise<SewDiskFee[]> => {
  try {
    const params = {
      resource: `${GET_SEW_DISK_FEES}/${documentId}`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch Sew Disk Fees: ${error}`);
    throw error;
  }
};

export const saveSewDiskFees = async (
  documentId: string,
  hours: number
): Promise<SewDiskFee[]> => {
  try {
    const params = {
      resource: `${GET_SEW_DISK_FEES}/${documentId}`,
      payload: { hours },
    };

    return await backendClient.put<{ hours: number }, SewDiskFee[]>(params);
  } catch (error) {
    console.error(`Failed to save Sew Disk Fees: ${error}`);
    throw error;
  }
};

export const getSewDiskChargesForDocumentId = async (documentId: string): Promise<SewDiskCharge[]> => {
  try {
    const params = {
      resource: `${GET_SEW_DISK_CHARGES}/${documentId}`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch Sew Disk Charges: ${error}`);
    throw error;
  }
};

export const getBCArtFeeForDocumentId = async (documentId: string): Promise<{unitPrice: number, saleStatus: string}> => {
  try {
    const params = {
      resource: `bc-art-fees/${documentId}`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch Art Fee Charges: ${error}`);
    throw error;
  }
};

export const getOriginalSewDiskChargesForDocumentId = async (documentId: string): Promise<{price:number,cost?:number}> => {
  try {
    const params = {
      resource: `${GET_SEW_DISK_CHARGES}/${documentId}/original`
    };

    return await backendClient.get(params);
  } catch (error) {
    console.error(`Failed to fetch Sew Disk Charges: ${error}`);
    throw error;
  }
};

export const getOriginalArtFeeForDocumentId = async (documentId: string): Promise<{price:number}[]|undefined> => {
  try {
    const params = {
      resource: 'DesignPrices',
      payload: { id:documentId, dwsProofPrice: true }
    };

    return backendClient.post<{id:string, dwsProofPrice: boolean }, {price:number}[]>(params);
  } catch (error) {
    console.error(`Failed to fetch price: ${error}`);
    return undefined
  }
};

export const saveSewDiskCharges = async (
  documentId: string,
  price: number,
  cost?: number
): Promise<SewDiskCharge[]> => {
  try {
    const params = {
      resource: `${GET_SEW_DISK_CHARGES}/${documentId}`,
      payload: { price, cost },
    };

    return await backendClient.put<{ price: number, cost?: number }, SewDiskCharge[]>(params);
  } catch (error) {
    console.error(`Failed to save Sew Disk Charges: ${error}`);
    throw error;
  }
};

export const saveBCArtFee = async (
  documentId: string,
  price: number,
): Promise<{unitPrice: number}> => {
  try {
    const params = {
      resource: `bc-art-fees/${documentId}`,
      payload: { price },
    };

    return await backendClient.put<{ price: number }, {unitPrice: number}>(params);
  } catch (error) {
    console.error(`Failed to save art fees: ${error}`);
    throw error;
  }
};

export const getEditParams = async (artIdParam: string): Promise<any> => {
  try {
    const headers = {
      'Content-Type': 'application/json'
    };

    const resp = await fetch(`${getBackendApiUrl()}/getEditParams`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        docId: artIdParam
      })
    })

    if (!resp.ok) throw new Error("Failed to get edit parameters for LN wizard");

    const editUrlData = await resp.json();
    if (Object.keys(editUrlData).length == 0 || !editUrlData.json) throw new Error("Failed to get edit parameters for LN wizard");

    return JSON.parse(editUrlData.json)

  } catch (error) {
    console.error(`Failed to fetch edit parameters: ${error}`);
    throw error;
  }
};

export const csrAuthenticate = async (
  username: string,
  password: string
): Promise<{ token: string; username: string }> => {
  try {
    const resp = await fetch(`${getBackendApiUrl()}/csr-auth`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    })

    if (!resp.ok) {
      const err = await resp.json().catch(() => ({ error: resp.statusText }))
      throw new Error(err.error || 'Authentication failed')
    }

    const data = (await resp.json()) as { token: string; username: string }
    localStorage.setItem('admintoken', data.token)
    localStorage.setItem('csrUsername', data.username)
    return data
  } catch (error) {
    console.error('Error during CSR auth:', error)
    throw error
  }
}

export const csrGetTasks = async (
  pageNumber: number = 1,
  pageSize: number = 15,
  assignedTo?: string,
  unassigned?: boolean,
  status?: string[]
): Promise<SelectAllQueryResult<ReviewTask>> => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('pageNumber', pageNumber.toString());
    queryParams.append('pageSize', pageSize.toString());

    if (assignedTo) queryParams.append('assignedTo', assignedTo);
    if (unassigned) queryParams.append('unassigned', '1');
    if (status && status.length > 0) {
      status.forEach(s => queryParams.append('status', s));
    }

    const params = {
      resource: `review-tasks?${queryParams.toString()}`
    };
    return backendClient.get<undefined, SelectAllQueryResult<ReviewTask>>(params);
  } catch (error) {
    console.error('Error occurred while fetching review tasks:', error);
    throw error;
  }
};

export const csrGetTaskDetails = async (
  designId: string
): Promise<ReviewTask> => {
  const params = { resource: `review-tasks/${designId}` };
  return backendClient.get<undefined, ReviewTask>(params);
};

export const csrLogout = (): void => {
  localStorage.removeItem('admintoken');
  localStorage.removeItem('csrUsername');
};

interface EasyViewEditResponse {
  easyViewEditURL: string;
}

export const getEasyViewEditConfigBaseURL$ = async (
  docId: string,
  wizardDocId: string,
  customerId: string,
  customerToken: string,
  enableTeamBuilder: boolean,
  importedDocId?: string,
  importedSessionid?: string,
  isEdge: boolean = true,
  openDoc: boolean = true
): Promise<string> => {
  try {
    const params = {
      resource: 'getEasyViewEditParams',
      payload: {
        docId,
        wizardDocId,
        customerId,
        enableTeamBuilder,
        isEdge,
        openDoc
      }
    };
    
    const response = await backendClient.post<typeof params['payload'], EasyViewEditResponse>(params);
    const url = new URL(response.easyViewEditURL);
  
    url.searchParams.set('customerToken', customerToken);
    url.searchParams.set('sana.editfromdashboard', 'true');
    
    if (importedDocId && importedSessionid) {
      url.searchParams.set('sana.importedDocId', importedDocId);
      url.searchParams.set('sana.importedSessionid', importedSessionid);
    }
    
    return url.toString();
  } catch (error) {
    console.error('Error in getEditConfigBaseURL$:', error);
    throw error;
  }
}

export const importToEasyView = async (
  fileId: string,
  sessionId: string,
  userId: string,
  isEdge?: boolean,
): Promise<any> => {
  try {
    const params = {
      resource: `${IMPORT_TO_EASYVIEW}`,
      payload: { fileId, userId, sessionId, isEdge },
    };

    return await backendClient.post(params);
  } catch (error) {
    console.error(`Failed to save Sew Disk Charges: ${error}`);
    throw error;
  }
};

export const impersonate = async (
  customerID: string,
): Promise<any> => {
  try {
    const params = {
      resource: `${IMPERSONATE}`,
      payload: { customerID },
    };

    return await backendClient.post(params);
  } catch (error) {
    console.error(`Failed to save Sew Disk Charges: ${error}`);
    throw error;
  }
};

export const setAsNotPurchased = async (documentId: string) => {
  const data = await fetch(`${getBackendApiUrl()}/design-purchases/${documentId}`, {
    method: 'DELETE',
    headers: addAuthorizationHeader({
      'Content-Type': 'application/json',
    }),
    body: "{}"
  })

  if (!data.ok)
    throw new Error("" + await data.text());
};

export const setAsPurchased = async (documentId: string) => {
  const timeStamp = new Date().toISOString();
  const data = await fetch(`${getBackendApiUrl()}/design-purchases`, {
    method: 'POST',
    headers: addAuthorizationHeader({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      designId: documentId,
      timeStamp: timeStamp,
    }),
  })

  if (!data.ok)
    throw new Error("" + await data.text());
};

export const resetSewFileData = async (documentId: string) => {
  const doc = await getWizardDocById(documentId)
  const originalDoc = await getWizardDocById(doc.originalDocID as string)
  const data = originalDoc.docType == 'LNTransfer' ? {wizardData: originalDoc.wizardData, BoM: originalDoc.BoM} : {wizardData: originalDoc.wizardData}
  const wizardSewFileChangeResp = await fetch(`${getBackendApiUrl()}/design-sew-disk-change/${originalDoc.id}`,
    {
      method: 'PUT',
      'headers': addAuthorizationHeader({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    }
  )
  if (!wizardSewFileChangeResp.ok) {
    const error = await wizardSewFileChangeResp.text()
    throw new Error(error)
  }
}